var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUploadlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 38,
    viewBox: "0 0 47 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 27L24 19L16 27",
    stroke: "#33358D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 19V37",
    stroke: "#33358D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.78 31.78C42.7307 30.7165 44.2717 29.0338 45.1598 26.9973C46.0479 24.9607 46.2325 22.6865 45.6845 20.5334C45.1364 18.3803 43.887 16.471 42.1334 15.1069C40.3797 13.7428 38.2218 13.0015 36 13H33.48C32.8747 10.6585 31.7464 8.48467 30.1799 6.64199C28.6135 4.7993 26.6497 3.3357 24.4362 2.36121C22.2227 1.38673 19.8171 0.926716 17.4003 1.01576C14.9834 1.10481 12.6182 1.7406 10.4824 2.87533C8.34662 4.01006 6.49586 5.6142 5.06929 7.56716C3.64271 9.52012 2.67742 11.7711 2.246 14.1508C1.81458 16.5305 1.92825 18.9771 2.57847 21.3065C3.22869 23.636 4.39853 25.7877 6.00004 27.6",
    stroke: "#33358D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 27L24 19L16 27",
    stroke: "#33358D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadlogo);
export default __webpack_public_path__ + "static/media/uploadlogo.22b9ccb080da4912ac9931dd16409719.svg";
export { ForwardRef as ReactComponent };